import { render, staticRenderFns } from "./InspectionsList.vue?vue&type=template&id=65b5fd0d&scoped=true&"
import script from "./InspectionsList.vue?vue&type=script&lang=js&"
export * from "./InspectionsList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionsList.vue?vue&type=style&index=0&id=65b5fd0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5fd0d",
  null
  
)

export default component.exports